import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactJson from 'react-json-view';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    fontSize: '2rem',
    '& > div': {
      backgroundColor: 'unset !important',
    },
  },
  icon: {
    width: '16rem',
    height: '16rem',
    margin: 'auto',
    color: theme.palette.text.secondary,
  },
});

const QuantificationConfig = (props) => {
  const { classes, configuration, theme } = props;
  const themeToUse = theme.palette.type === 'dark' ? 'monokai' : 'rjv-default';
  return (
    <div className={classes.root}>
      <ReactJson src={configuration} theme={themeToUse} />
    </div>
  );
};

QuantificationConfig.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  theme: PropTypes.instanceOf(Object).isRequired,
  depth: PropTypes.number.isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    path: PropTypes.string,
  }).isRequired,
  configuration: PropTypes.instanceOf({
    configuration: PropTypes.instanceOf({
      tree_id: PropTypes.number,
    }).isRequired,
    engine: PropTypes.instanceOf({
      BBNSolver: PropTypes.number,
      OrderingRule: PropTypes.number,
      BDDConstructor: PropTypes.number,
    }).isRequired,
    quantify: PropTypes.instanceOf({
      targets: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default withStyles(styles, { withTheme: true })(QuantificationConfig);
